export default __webpack_public_path__ + "static/media/insight_light_mode.22b9f236.svg";